export default __webpack_public_path__ + "static/media/logo-400.b54fad63.png";